import * as React from 'react';
import SignaturePad from 'signature_pad';

import '../../stylesheets/components/SignatureBox.scss';

type SignatureBoxProps = {
  inputName: string,
  signatureImage?: string,
}

class SignatureBox extends React.Component<SignatureBoxProps> {
  _canvasEl = null;
  signaturePad = null;

  state = {
    signatureImage: "",
    isDrawing: false,
    clearOnDraw: false,
  }

  constructor(props: any) {
    super(props);

    this.state.signatureImage = props.signatureImage || ''; 
    if(props.signatureImage) {
      this.state.clearOnDraw = true;
    }
  }

  _resizeSignatureCanvas = () => {
    const canvas = this._canvasEl;

    if(canvas.originalHeight !== null) { 
      canvas.originalHeight = canvas.offsetHeight;
      canvas.originalWidth = canvas.offsetWidth;
    }
    console.log(canvas.originalHeight);
    var ratio =  Math.max(window.devicePixelRatio || 1, 1);
    console.log(ratio);
    canvas.width = canvas.originalWidth * ratio;
    canvas.height = canvas.originalHeight * ratio;

    canvas.getContext("2d").scale(ratio, ratio);
    this.signaturePad.clear(); // otherwise isEmpty() might return incorrect value
  }

  componentDidMount() {
    this.signaturePad = new SignaturePad(this._canvasEl);
  
    //window.addEventListener("resize", this._resizeSignatureCanvas);
    //this._resizeSignatureCanvas();


    this.signaturePad.addEventListener('endStroke', this.handleChange);
    this.signaturePad.addEventListener('beginStroke', () => {  
      console.log("Begun stroke.")
      if(this.state.clearOnDraw) {
        this.signaturePad.clear();
        this.setState({
          isDrawing: true,
          signatureImage: '',
          clearOnDraw: false,
        });
      } else {
        this.setState({
          isDrawing: true,
        });
      }
    });

    // Load image if already exists?
    if(this.state.signatureImage != "") {
      this.signaturePad.fromDataURL(this.state.signatureImage);
    }
  }

  handleClear = (e: any) => {
    e && e.preventDefault();
    this.signaturePad.clear();
    this.setState({
      signatureImage: '',
    })
  }

  handleChange = () => {
    this.setState({
      signatureImage: this.signaturePad.toDataURL("image/png"),
      isDrawing: false,
    });
  }

  render() {
    const showPlaceholder = this.state.signatureImage == '' && !this.state.isDrawing; 

    return(
      <div className="SignatureBox">
        <canvas id="signature_pad" 
          ref={ el => this._canvasEl = el }></canvas>

        { showPlaceholder && <div className="Placeholder">Draw signature here</div>   }

        <button className="btn btn-secondary ClearButton" onClick={this.handleClear}>
          <i className="ti ti-eraser me-1"></i>
          Clear
        </button>
        <input type="hidden" name={this.props.inputName} 
          value={this.state.signatureImage} />
      </div>
    );
  }
}

export default SignatureBox;
